import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { Draft } from "immer";
import MyPurchaseHistoryConfigState from "../Data/ADIMyPurchaseHistoryConfigState";

export const defaultPaginationValues = {
    page:1,
    currentPage: 1,
    pageSize: 12,
    defaultPageSize: 12,
    totalItemCount: 0,
    numberOfPages: 26,
    pageSizeOptions: [12,24,36,48],
    sortOptions: null,
    sortType: "",
    nextPageUri: "",
    prevPageUri: "",
};

const getTodaysDate = () => {
    const today = new Date();
    const yyyy = today.getFullYear();
    let mm = String(today.getMonth() + 1).padStart(2, "0");
    let dd = String(today.getDate()).padStart(2, "0");
    const formattedToday = mm + "/" + dd + "/" + yyyy;
    return formattedToday;
};

const convertDateFormat = (date: any) => {
    const formattedDate = new Date(date);
    const month = String(formattedDate.getMonth() + 1).padStart(2, "0");
    const day = String(formattedDate.getDate()).padStart(2, "0");
    const year = formattedDate.getFullYear();
    return `${year}/${month}/${day}`;
};

const todayDate = new Date();
const defaultToDate = convertDateFormat(todayDate)
const defaultFromDate = convertDateFormat(new Date(new Date().setDate(new Date().getDate() - 30)));

const initialState: MyPurchaseHistoryConfigState = {
    toDate: defaultToDate,
    fromDate: defaultFromDate,
    searchText: "",
    pageName: "purchasehistory",
    pagination: defaultPaginationValues,
};

const reducer = {
    "Custom/MyPurchaseHistory/PopulateConfigParam": (draft: Draft<MyPurchaseHistoryConfigState>) => {},
    "Custom/MyPurchaseHistory/CleanConfig": (draft: Draft<MyPurchaseHistoryConfigState>) => {
        draft.toDate = "";
        draft.fromDate = "";
        draft.searchText = "";
        draft.pageName = "purchasehistory";
        draft.pagination = defaultPaginationValues;
    },

    "Custom/MyPurchaseHistory/SetConfig": (
        draft: Draft<MyPurchaseHistoryConfigState>,
        action: { result: MyPurchaseHistoryConfigState },
    ) => {
        draft.toDate = action.result.toDate || "";
        draft.fromDate = action.result.fromDate || "";
        draft.searchText = action.result.searchText || "";
        draft.pageName = action.result.pageName || "";
        draft.pagination = action.result.pagination || defaultPaginationValues;
    },
};

export default createTypedReducerWithImmer(initialState, reducer);
